
import ViewHeader from "@/components/ViewHeader.vue";
import { api } from "@/services/Api";
import { useStore } from "@/store";
import { saveDefaultPrinterSettings, savePrinterSettings } from "@/utils/printer";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, ref, onActivated, onDeactivated, onUnmounted, onMounted } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "MainMenu",
  components: { ViewHeader },
  async setup() {
    const { t } = useI18n();
    const preload = ref(true);
    const mounted = ref(false);
    const store = useStore();

    async function load() {
      if (!preload.value) {
        return;
      }
      const response = await api.preloadPricesAndSlots(moment().format("YYYY-MM-DD"));
      if (response.error) {
        Swal.fire({
          icon: "error",
          text: response.errorMessage,
        });
      } else {
        store.commit("setPreload", response.data);
      }

      mounted.value = true;
      setTimeout(async () => {
        await load();
      }, 60000);
    }

    async function checkPrinterSettings() {
      const printerSettings = store.getters.printerSettings;

      if (printerSettings) {
        return;
      }

      await Swal.fire(
        {
          text: t("cashier.printer.initial-default"),
          icon: "info",
          iconColor: "",
          confirmButtonText: t("cashier.label.ok"),
          customClass: {
            confirmButton: "popup-bookit-button",
          },
          buttonsStyling: false,
          allowOutsideClick: false
        }
      )

      await saveDefaultPrinterSettings();
    }

    onDeactivated(() => (preload.value = false));
    onUnmounted(() => (preload.value = false));

    onActivated(() => {
      if (mounted.value) {
        preload.value = true;
        load();
      }
    });

    onMounted(() => {
      preload.value = true;
      load();
      checkPrinterSettings();
    });

    const mainMenuSelect = ref(0);

    function selectMenuItem(itemNumber: number) {
      mainMenuSelect.value = itemNumber;
    }

    return { t, mainMenuSelect, selectMenuItem };
  },
});
